import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RecordingComponent } from "./recording.component";
import { RecordingSchedulerComponent } from "./recording-scheduler/recording-scheduler.component";
import { RecordingHistoryComponent } from "./recording-history/recording-history.component";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { RecordingRoutes } from "./recording.routes";
import { AssetItemComponent } from "./recording-assets-manager/asset-item/asset-item.component";
import { RecordingAssetsManagerComponent } from "./recording-assets-manager/recording-assets-manager.component";
import { AssetGroupComponent } from "./recording-assets-manager/asset-group/asset-group.component";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { RecordingRepository } from "../../domain/recording-repository";
import { RecordingRepositoryImpl } from "../../infrastructure/repositories/recording/recording";
import { RecordingService } from "../../services/recording/recording.service";
import { RecordingJobActionsComponent } from "./recording-scheduler/recording-job-actions/recording-job-actions.component";
import { AddOrEditRecordingJobComponent } from "./recording-scheduler/add-or-edit-recording-job/add-or-edit-recording-job.component";
import { RecordingJobSourcesComponent } from "./recording-scheduler/recording-job-sources/recording-job-sources.component";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
      enableHtml: true,
    }),
    RouterModule.forRoot(RecordingRoutes),
    AgGridModule,
  ],
  declarations: [
    RecordingComponent,
    RecordingSchedulerComponent,
    RecordingHistoryComponent,
    AssetItemComponent,
    RecordingAssetsManagerComponent,
    AssetGroupComponent,
    RecordingJobActionsComponent,
    AddOrEditRecordingJobComponent,
    RecordingJobSourcesComponent,
  ],
  providers: [
    RecordingService,
    {
      provide: RecordingRepository,
      useClass: RecordingRepositoryImpl,
    },
  ],
  exports: [RouterModule, InlineSVGModule, ToastrModule],
})
export class RecordingModule {}
